"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsurerModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const jwt_1 = require("@nestjs/jwt");
const typeorm_1 = require("@nestjs/typeorm");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils"); // Import EntityService
const lookup_validation_1 = require("../../../../../services/service-lib/src/lib/utils/lookup-validation");
const auth_guard_1 = require("../../../../auth-service/src/guards/auth.guard"); // Import AuthGuard here
const role_guard_1 = require("../../../../auth-service/src/guards/role.guard"); // Import RolesGuard here
const insurer_address_entity_1 = require("../../../../service-lib/src/lib/entities/insurer-address.entity");
const insurer_contact_entity_1 = require("../../../../service-lib/src/lib/entities/insurer-contact.entity");
const insurer_entity_1 = require("../../../../service-lib/src/lib/entities/insurer.entity");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const address_module_1 = require("../address/address.module"); // Import AddressModule
const contact_module_1 = require("../contact/contact.module"); // Import ContactModule
const look_up_module_1 = require("../look-up/look-up.module");
const look_up_repository_1 = require("../look-up/look-up.repository");
const insurer_controller_1 = require("./insurer.controller");
const insurer_repository_1 = require("./insurer.repository");
const insurer_service_1 = require("./insurer.service");
const masters_validation_1 = require("../../../../service-lib/src/lib/utils//masters-validation");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
let InsurerModule = class InsurerModule {
};
exports.InsurerModule = InsurerModule;
exports.InsurerModule = InsurerModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forFeature([insurer_entity_1.Insurer, insurer_address_entity_1.InsurerAddress, insurer_contact_entity_1.InsureContact, look_up_entity_1.LookUp]),
            address_module_1.AddressModule,
            contact_module_1.ContactModule,
            look_up_module_1.LookUpModule,
            jwt_1.JwtModule,
        ],
        controllers: [insurer_controller_1.InsurerController],
        providers: [
            insurer_service_1.InsurerService,
            insurer_repository_1.InsurerRepository,
            lookup_validation_1.LookUpValidationService,
            entity_service_utils_1.EntityService,
            look_up_repository_1.LookUpRepository,
            auth_guard_1.AuthGuard,
            role_guard_1.RolesGuard,
            masters_validation_1.MasterValidationService,
            scope_utils_1.ScopeService
        ],
        exports: [insurer_service_1.InsurerService, insurer_repository_1.InsurerRepository],
    })
], InsurerModule);
